// "你这周" widget. Top of /my-tasks. 3-up: 完成 N | 评论 M | 创建 K.
// Fetches GET /me/weekly on mount. Quiet placeholders on failure.

import { useState, useEffect } from 'react';
import * as api from '../lib/api.ts';

export const WeeklyWidget = () => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.loadMyWeekly()
      .then(d => { if (!cancelled) setData(d); })
      .catch(() => { if (!cancelled) setErr(true); });
    return () => { cancelled = true; };
  }, []);

  // Quiet failure: render dashes rather than an error banner. Telemetry-adjacent
  // surfaces should not nag users about themselves.
  const fmt = (v) => err || data == null ? '—' : v;

  return (
    <div className="weekly-widget" aria-label="本周你的活动">
      <div className="weekly-tile">
        <div className="weekly-num">{fmt(data?.tasks_completed_7d)}</div>
        <div className="weekly-label">本周完成</div>
      </div>
      <div className="weekly-tile">
        <div className="weekly-num">{fmt(data?.comments_7d)}</div>
        <div className="weekly-label">回复 / 进度</div>
      </div>
      <div className="weekly-tile">
        <div className="weekly-num">{fmt(data?.tasks_created_7d)}</div>
        <div className="weekly-label">你派出 / 自己开</div>
      </div>
    </div>
  );
};
